module.exports = __webpack_public_path__ + "img/banner3.7ba82cfc.png";